export const getEnumKeys = <T>(enume: any) =>
	Object.keys(enume)
		.map((key) => enume[key as keyof T])
		.filter((value) => typeof value === 'number')
